import type { GetServerSidePropsContext, NextPage } from 'next';
import { useRouter } from 'next/router';
import Container from '../../components/container/container.component';
import NoLatestNews from '../../components/latest-news/no-latest-news/no-latest-news.component';
import Pagination from '../../components/pagination/pagination.component';
import PostsListItemComponent from '../../components/posts-list-item/posts-list-item.component';
import SectionTitle from '../../components/section-title/section-title.component';
import { getPostsListByCategory } from '../../lib';
import Page from '../../templates/page.template';
import { PostsListProps } from '../../types/posts-list-props.interface';

interface Props extends PostsListProps { }

const DiscoveriesListPage: NextPage<Props> = ({ menu, options, posts }) => {
  const router = useRouter();
  return (
    <Page
      menu={menu}
      options={options}
      title="Projects"
      description={options.description}
    >
      <Container column={true} css={{ marginTop: '40px' }}>
        <SectionTitle title="Projects" />
        <div className="posts-wrapper">
          {posts.length ? (
            posts.map((post) => (
              <PostsListItemComponent
                post={post}
                key={post.id}
                baseUrl={options.baseUrl}
                path="projects"
                hideDetails={true}
              />
            ))
          ) : (
            <NoLatestNews category="projects" />
          )}
        </div>
        <Pagination router={router} nbHits={posts.length} pageSize={10} />
      </Container>
    </Page>
  );
};

export async function getServerSideProps(props: GetServerSidePropsContext) {
  const page = props.query.page;
  const data = await getPostsListByCategory('project', Number(page), 10);

  props.res.setHeader('Cache-Control', 'public, max-age=300, s-maxage=300');

  return { props: data };
}

export default DiscoveriesListPage;
